import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { OcFormSwitch } from "oc/components";

interface MyCafeteriaPlanSwitchProps {
  newItem: { plan: boolean };
  handleChange: (updatedItem: { plan: boolean }) => void;
}

export const MyCafeteriaPlanSwitch: React.FC<MyCafeteriaPlanSwitchProps> = ({
  newItem,
  handleChange,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Box width="45px" textAlign="right">
        <Typography
          variant="body1"
          style={{
            textTransform: "capitalize",
            color: theme.palette.owGray.main,
          }}
        >
          {t("MY_CAFETERIA_PLAN")}
        </Typography>
      </Box>
      <Box width="16px" />
      <Box>
        <OcFormSwitch
          id="cafeteria-plan"
          checked={newItem?.plan || false}
          onChange={() => {
            return handleChange({
              plan: !newItem?.plan,
            });
          }}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Box>
    </>
  );
};

export default MyCafeteriaPlanSwitch;
